export enum pType {
    INTEGER = "int",
    FLOAT = "float",
    TEXT = "text",
    BOOLEAN = "boolean",
    LISTINTEGER = "intList",
    LISTFLOAT = "floatList",
    LISTTEXT = "textList",
    SEEDFORRANDOM = "seedForRandom",
    GENERATEDQUESTIONS = "generatedQuestions",
    ENUM = "enum" //array di array [[chiave,valore]] default value tra una delle chiavi
}

export enum genType {
    FIXED = "fixed",
    GENERATED = "generated",
    CALCTODAY = "calculated@today",
    CALCDAYOMON = "calculated@dayofmonth",
    CALCMONTH = "calculated@month",
    CALCYEAR = "calculated@year"
}


export class TaskParameter {
    label: string;
    key: string;
    description: string;
    type: pType;
    unit?: string;
    defaultValue: any;
    min?: number;
    max?: number;
    content?: any;
    value: any;

    constructor() {
        this.label = "";
        this.description = "";
        this.key = "";
        this.unit = "";
        this.type = pType.INTEGER;
        this.defaultValue = "";
        this.content = null;

    }

}

export class SeedForRandom { //solo questi 4
    s0: number;
    s1: number;
    s2: number;
    s3: number;

    constructor() {
        this.s0 = 0
        this.s1 = 0
        this.s2 = 0
        this.s3 = 0
    }

}

export class generatedQuestions { //possono essere n
    question: string
    correct: string[] | string
    noOfAnswers: number
    answers: string[] | string
    gen_type: genType

    constructor() {
        this.question = ""
        this.correct = []
        this.answers = []
        this.gen_type = genType.FIXED
        this.noOfAnswers = 0
    }

}

export class enumerator {
    key: string;
    value: string;

    constructor() {
        this.key = ""
        this.value = ""
    }

}
/*
    enum = [{key:'', value:''},{key:'', value:''}]
*/
